<template>
  <nio-teleport to="#nio-config-content" v-if="enableTeleport">
    <div v-if="isVisible" class="fullscreen-overlay">
      <div class="video-area">
        <nio-video
            :src="source"
            :poster="posterImage"
            :loop="false"
            :autoplay="true"
            :controller="true"
            object-fit="contain"
            :pause-on-video-click="true"
        />
        <div class="close-icon" @click="closeAction">
          <nio-icon class="icon" type="close" raw></nio-icon>
        </div>
      </div>
    </div>
  </nio-teleport>
  <div v-else-if="!enableTeleport&&isVisible" class="fullscreen-overlay">
    <div class="video-area">
      <nio-video
          :src="source"
          :poster="posterImage"
          :loop="false"
          :autoplay="true"
          :controller="true"
          object-fit="contain"
          :pause-on-video-click="true"
      />
      <div class="close-icon" @click="closeAction">
        <nio-icon class="icon" type="close" raw></nio-icon>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref,} from 'vue';
import {nioJsBridge} from "@nio-wad/universal-bridge-h5";
import { isTpad } from '@common/utils'

defineProps({
  enableTeleport: {
    type: Boolean,
    default:false
   },
})
const source = ref('');
const posterImage = ref('');

const isVisible = ref(false);
const previewPhoto=(src:string,poster?:string)=>{
  nioJsBridge.previewPhoto({
    data:{
      urls:[src],
      position:0,
    }as any
  })
}
const toggle = (src?:string,poster?:string) => {
  if (!isVisible.value && src) {
    if(isTpad){
      previewPhoto(src,poster)
      return
    }
    source.value = src;
    posterImage.value = poster || '';
    isVisible.value = true;
  } else {
    source.value = '';
    posterImage.value = '';
    isVisible.value = false;
  }
};
const closeAction = ()=>{
  toggle();
};

defineExpose({
  toggle,
  play:toggle
});
</script>

<style scoped lang="scss">
.fullscreen-overlay {
  position: fixed;
  top: 44px;
  left: 0;
  width: 100%;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8); // 半透明黑色背景
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}
.video-area{
  width: 100%;
  height: 100%;
  position: relative;
  .close-icon{
    position: absolute;
    top: 32px;
    right: 32px;
    z-index: 50;
    cursor: pointer;
    .icon{
      width:100%;
      height:100%;
    }
  }
}

</style>
